import { combineEpics } from "redux-observable";
import { rootEpic as rootEpic$1 } from "./views/EmergencyShutdown/epics/epics.js";
const rootEpic = combineEpics(rootEpic$1);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
